export const getBrowserId = () => {
  return (
    localStorage.getItem('browserId') ??
    sessionStorage.getItem('browserId') ??
    ''
  );
};
